export default __webpack_public_path__ + "static/media/facebook.4ba63ef5.svg";